const key = "AIzaSyD2E7X-Bnz3jLlofRLhWEOgSBydICUQ2rs";

export const G_API_URL = `https://maps.googleapis.com/maps/api/js?key=${key}&&v=3.exp&libraries=geometry,drawing,places`;
